import React, { useState, useEffect, useRef } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer } from 'react-toastify';
import { ListsModal } from '../../contexts';
import AddEvent from '../../components/Modals/AddEvent';
import SendTxt from '../../components/Modals/SendTxt';
import SendEmail from '../../components/Modals/SendEmail';
import LogComms from '../../components/Modals/LogComms';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import NamesInGrid from './NamesInGrid';
import Call from '../../components/Call';

import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';

const Calls = ( { aid, uid, user, viewing, canExport, tasks, gameplan, contacts, status, meta } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [show, setShow] = useState( false );
    const closeModal = () => setShow( false );
    const openModal = () => setShow( true );
    const [ modal, setModal ] = useState();
    const [ loading, setLoading ] = useState( true );
    const [ calls, setCalls ] = useState( [] );
    const [ callLookup, setCallLookup ] = useState( {} );
    const [ selectedTid, setSelectedTid ] = useState( '' );
    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    let cols = [
        { field: 'type', headerName: 'Call Type', width: 75 },
        { field: 'reason', headerName: 'Subject', width: 175, renderCell: ( params ) => <Link to={ '#' } onClick={ () => setSelectedTid( params.row.id ) }>{params.value}</Link> },
        { 
            field: 'c', 
            headerName: 'Contact', 
            width: 175, 
            renderCell: ( params ) => <NamesInGrid row={params.row} />, 
            valueGetter: ( params ) => {
                // let v = [];
                // params.row.assoc.forEach( b => {
                //     if ( b ) {
                //         const c = contacts[b.cid]; // cl.find( f => f.cid === b.cid );
                //         if ( c ) { v.push( c.name ); }
                //     }
                // } );
                // return v.join( ', ' );
                return params.row.c.name;
            }
        },
        { field: 'phone', headerName: 'Phone', width: 150 },
        { field: 'phoneMobile', headerName: 'Mobile Phone', width: 150 },
        { field: 'dueDate', headerName: 'Due', type: 'date', width: 100, valueGetter: ( { value } ) => value && new Date( value + 'T12:00:00' ) },
        { field: 'assignedTo', headerName: 'Assigned To', width: 150 }
    ];

    const containerRef = useRef();
    const titleRef = useRef();
    
    const gridRef = useGridApiRef();

    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    {/* <Row className='p-0 align-items-center'>
                        <Col>
                            <Row className='text-start align-items-center'>
                                <Col xs='auto' className='pe-0'>
                                    <GridFooter className='tf-fake-footer' />
                                </Col>
                                <Col>
                                    { 
                                        selectedRows.length > 0 &&
                                        <Row style={ { borderLeft: '1px solid #CCC' } }>
                                            <Col xs='auto' className='pe-2'>Take Action...</Col>
                                            <Col xs='auto' className='ps-0'>
                                                <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'email-mass' ) }>Send Email</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'sms-mass' ) }>Send Txt</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'phoneburner' ) }>Launch Phoneburner</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'list' ) }>Add to a List</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'event' ) }>Add to an Event</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'reschedule' ) }>Remind Me Tomorrow</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'delete' ) }>Delete</Dropdown.Item>
                                                </DropdownButton>
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row> */}
                    <Row className='p-0 align-items-center'>
                        <Col className='text-left'>
                            <GridToolbarQuickFilter />
                        </Col>
                        {
                            ( canExport ) ? (
                                <Col xs='auto' className='pe-3 text-right'>
                                    <GridToolbarExport />
                                </Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }
    
    const handleSingleModal = ( t, cid ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'log-call':
                console.log( 'log-call w/ cid: ' + cid );
                setModal( <LogComms commType='Call' close={closeModal} cid={cid} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'unknown modeal type for single: ' + t + ' - ' + cid )  ;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleMassModal = ( t ) => {
        let shouldOpen = true;

        let contacts = [];
        selectedRows.forEach( r => {
            console.log( r );
            // const [ loid, cid ] = r.split( '#' );
            // contacts.push( leads.find( f => f.cid === cid ) );
        } );

        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail contacts={ contacts } close={ closeModal } /> ); 
                break;

            case 'sms-mass':
                setModal( <SendTxt contacts={ contacts } close={ closeModal } /> ); 
                break;
    
            case 'phoneburner':
                setModal( <div>phoneburner</div> ); 
                break;
        
            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'email':
                setModal( <SendEmail /> );
                break;

            case 'sms':
                setModal( <SendTxt /> );
                break;

            case 'event':
                setModal( <AddEvent /> );
                break;

            default:
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
        
        console.log( 'modal: ' + t );
    }

    useEffect( () => {
        document.title = 'Third Floor - Calls';
    }, [] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        let list = [];
        const today = new Date();

        if ( tasks ) {
            Object.keys( tasks ).forEach( f => {
                const t = tasks[f];
                if ( !viewing.includes( t.aid ) ) {
                    return;
                }

                if ( t.assignedTo === uid && t.type === 'Call' && Date.parse( t.dueDate ) <= Date.now() ) {
                    if ( [ 'Open', 'Not Started' ].includes( t.status ) ) {
                        // open++;
                        const ta = t.assoc[0];
                        const c = contacts[ta?.cid];
                        if ( c ) {
                            list.push( {
                                id: t.tid,
                                oid: t.tid,
                                reason: t.name,
                                details: t.details,
                                c: c,
                                type: 'Manual',
                                assignedTo: t.assignedTo,
                                dueDate: t.dueDate,
                                phone: c.phone,
                                phoneMobile: c.phoneMobile
                            } );
                        } else {
                            console.log( 'open task with no contact:', t );
                        }
                        
                    } else if ( t.status === 'Completed' && t.completedDate ) {
                        const cd = t.completedDate?.split( 'T' )[0];
                        const [ yr, mon, d ] = cd?.split( '-' );
                        if ( parseInt( yr ) === today.getFullYear() && parseInt( mon ) === today.getMonth() + 1 && parseInt( d ) === today.getDate() ) {
                            // completed++;
                        }
                    }
                }
            } );
        }

        if ( gameplan ) {
            Object.keys( gameplan ).forEach( f => {
                const gp = gameplan[f];
                const [ yr, mon, d ] = gp.dueDate.split( '-' );
                if ( !viewing.includes( gp.aid ) ) {
                    return;
                }

                if ( gp.assignedTo === uid && parseInt( yr ) === today.getFullYear() && parseInt( mon ) === today.getMonth() + 1 && parseInt( d ) === today.getDate() ) {
                    if ( gp.status === 'Open' ) {
                        // open++;
                        const c = contacts[gp.cid];
                        list.push( {
                            id: gp.gpid,
                            oid: gp.gpid,
                            reason: gp.reason,
                            details: '',
                            c: c,
                            type: 'Theme',
                            assignedTo: gp.assignedTo,
                            dueDate: gp.dueDate,
                            phone: c.phone,
                            phoneMobile: c.phoneMobile
                        } );
                    } else if ( gp.status === 'Completed' ) {
                        // completed++;
                    }
                }
            } );
        }
        
        list.sort( ( a, b ) => {
            const aid = a.id.split( '_' )[0];
            const bid = b.id.split( '_' )[0];

            // both are same type - either gp or task
            if ( aid === bid ) {
                if ( aid === 'task' ) {
                    const at = tasks[a.id];
                    const bt = tasks[b.id];
                    const add = new Date( at.dueDate );
                    const bdd = new Date( bt.dueDate );

                    return add.getTime() - bdd.getTime();
                }
                // must both be gameplans - push bdays to the top
                if ( a.sub === b.sub ) {
                    return 0;
                }
                if ( b.sub === 'Birthday Call' ) {
                    return 1;
                }
                if ( a.sub === 'Birthday Call' ) {
                    return -1;
                }

                return b.sub.localeCompare( a.sub );
            }
            
            if ( bid === 'task' ) {
                return 1;
            }
            
            return -1;
        } );

        let lookup = {};
        list.forEach( c => {
            lookup[c.id] = c;
        } );
        setCallLookup( lookup );

        console.log( 'call list: ', list );
        setCalls( list );
        setLoading( false );
    }, [ tasks, gameplan, contacts, uid, viewing ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='mx-1' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <ListsModal.Provider value={ { openModal, closeModal, setModal } }>
                    <Col className='tf-section-container mx-2 p-0' xs={4} md={3} style={ { height: '100%' } }>
                        <Row className='p-2' ref={titleRef}>
                            <Col>
                                <VscFolderActive />
                                <span className='ps-2 fw-bold fs-6'>Calls</span>
                            </Col>
                        </Row>
                        <Row className='p-0 m-0'>
                            <Col className='p-0' style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                <DataGridPro
                                    apiRef={gridRef}
                                    loading={ loading }
                                    rows={calls}
                                    columns={cols}
                                    density='compact'
                                    checkboxSelection
                                    disableSelectionOnClick
                                    slots={ { toolbar: toolbar } }
                                    onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                    getRowHeight={ () => 'auto' }
                                    sx={ {
                                        border: 0
                                    } }
                                    hideFooter={true}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col className='tf-section-container mx-2 p-0' style={ { height: '100%' } }>
                        {
                            ( selectedTid && callLookup[selectedTid] ) ? (
                                <Call obj={callLookup[selectedTid]} />
                            ) : (
                                <span>No Call Selected Yet.</span>
                            )
                        }
                    </Col>
                </ListsModal.Provider>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal show={show} onHide={closeModal} centered size='lg'>
                {modal}
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    team: state.user.lists.team,
    tasks: state.tasks.byId,
    gameplan: state.gameplan.byId,
    contacts: state.contacts.byId,
    status: state.user.meta.task.picklist.status,
    meta: state.user.meta.task
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Calls );